import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAccountApprovalsPreference } from 'services/ApprovalsService'

export const useAccountApprovalsPreferenceQuery = (accountReference: string, isEnabled = false) => {
  return useQuery({
    queryKey: reactQueryKeys.accountApprovalsPreference(accountReference),
    queryFn: getAccountApprovalsPreference,
    enabled: isEnabled,
  })
}
